module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan4-3-208c839bb4363860ee2506c21065b6cd.webp";